import styled from "@emotion/styled"

const ListSixteenItemInner = styled.div`
  min-width: 70%;
`

export default ListSixteenItemInner
